export { default } from '@tiger/debug';
